/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, HFlow, Theme, useTheme, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { useMemo } from 'react'

import { ExameQueryModel } from '../../model'
import { getResultadoExameEspecificoProperties } from '../../util'

interface CardResultadoExameContainerProps {
  exame: ExameQueryModel
  children: React.ReactNode
  headerButtons?: React.ReactNode
}

export const CardResultadoExameContainer = (props: CardResultadoExameContainerProps) => {
  const { exame, children, headerButtons } = props

  const theme = useTheme()
  const classes = useMemo(() => styles(theme), [theme])

  const { unit } = getResultadoExameEspecificoProperties(exame)

  return (
    <Box style={classes.box}>
      <VFlow vSpacing={0}>
        <HFlow alignItems='center' justifyContent='space-between' style={classes.header}>
          <Heading level={4} fontWeight='bold'>
            {exame.descricao.titleCase() + (unit ? ` (${unit})` : '')}
          </Heading>

          {headerButtons}
        </HFlow>

        {children}
      </VFlow>
    </Box>
  )
}

const styles = (theme: Theme) => ({
  box: css`
    padding: 0.5rem;
    background: ${theme.pallete.gray.c90};
  `,
  header: css`
    margin-bottom: 0.5rem;
  `,
})
